import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PBOptions } from '@models/progress-bar.model';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
})
export class ProgressBarComponent implements OnInit {
    @Input() options: PBOptions;
    @Input() forceHide: boolean = false;
    @Output() reload = new EventEmitter<any>();

    private time: number = 500; // ms
    public visible: boolean = true;
    public status: 'start' | 'middle' | 'end' | 'success' | 'warning' | 'error';
    private defaultOptions: PBOptions = {
        showText: true,
        backgroundColor: '#011638',
        callback: true,
    };

    constructor() {}

    ngOnInit() {
        if (!this.options) {
            this.options = this.defaultOptions;
        }
    }

    show(): void {
        this.visible = true;
    }

    hide(): void {
        this.visible = false;
    }

    changeStatus(
        newStatus: 'start' | 'middle' | 'end' | 'success' | 'warning' | 'error'
    ): void {
        this.status = newStatus;
    }

    start(): void {
        this.visible = true;
        this.status = 'start';
    }

    middle(): void {
        this.status = 'middle';
    }

    end(): void {
        this.status = 'end';
        setTimeout(() => {
            this.hide();
        }, this.time);
    }

    success(): void {
        this.status = 'success';
    }

    error(): void {
        this.status = 'error';
    }

    sendRefresh(): void {
        this.reload.emit(true);
    }
}
